var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.78,
    y: 214.86,
    width: 89.68,
    height: 171.12,
    rx: 5.21,
    transform: "translate(-124.83 78.39) rotate(-26.88)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.66,
    cy: 260.56,
    r: 6.55,
    transform: "translate(-135.43 77.08) rotate(-33.92)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.67,
    cy: 243.33,
    r: 6.55,
    transform: "matrix(0.94, -0.35, 0.35, 0.94, -78.99, 47.55)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,289.22a6.55,6.55,0,1,1-8.81-2.88A6.56,6.56,0,0,1,80.53,289.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.69,
    cy: 274.94,
    r: 6.55,
    transform: "translate(-169.77 374.26) rotate(-88.06)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,320.84A6.55,6.55,0,1,1,87.74,318,6.55,6.55,0,0,1,96.55,320.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.56,303.6a6.55,6.55,0,1,1-8.8-2.88A6.55,6.55,0,0,1,130.56,303.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,352.46a6.55,6.55,0,1,1-8.81-2.89A6.55,6.55,0,0,1,112.58,352.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,335.22a6.55,6.55,0,1,1-8.81-2.88A6.56,6.56,0,0,1,146.59,335.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,254.61a38,38,0,0,1-1.75,5.92,37.88,37.88,0,0,1-2.23,5.75,36.31,36.31,0,0,1,1.74-5.92A36.09,36.09,0,0,1,60.53,254.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.79,237.44a35.7,35.7,0,0,1-1.74,5.92,36.46,36.46,0,0,1-2.24,5.76,36.38,36.38,0,0,1,1.75-5.92A38.29,38.29,0,0,1,93.79,237.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,286.18a37.85,37.85,0,0,1-1.41,6.16,37.72,37.72,0,0,1-1.92,6A37.8,37.8,0,0,1,75,292.2,38.81,38.81,0,0,1,76.88,286.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.45,268.93a35.06,35.06,0,0,1-1.13,6,35.1,35.1,0,0,1-1.63,5.84,35.38,35.38,0,0,1,1.12-6A36.37,36.37,0,0,1,110.45,268.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.82,317.81a32.09,32.09,0,0,1-1.29,5.64,32.75,32.75,0,0,1-1.8,5.51,31.63,31.63,0,0,1,1.3-5.64A32.23,32.23,0,0,1,91.82,317.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,301a32.35,32.35,0,0,1-1.74,5.61,34.42,34.42,0,0,1-2.23,5.44,32.35,32.35,0,0,1,1.74-5.61A34.93,34.93,0,0,1,126.78,301Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.89,349.76A37.49,37.49,0,0,1,107,355.6a36.86,36.86,0,0,1-2.4,5.65,35.64,35.64,0,0,1,1.91-5.83A35.05,35.05,0,0,1,108.89,349.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.66,331.47a42,42,0,0,1-1.38,6.54,42.65,42.65,0,0,1-1.88,6.41,43.43,43.43,0,0,1,1.38-6.54A42.65,42.65,0,0,1,142.66,331.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,351.64c.06.13-10.34,5.53-23.23,12.06s-23.4,11.73-23.47,11.61,10.34-5.53,23.23-12.07S158.75,351.51,158.82,351.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.33,225c.06.13-10.34,5.53-23.23,12.07s-23.4,11.73-23.47,11.6S55,243.09,67.86,236.55,91.26,224.82,91.33,225Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.62,243.35a.42.42,0,0,1-.18,0s-.06,0-.08,0l0,0h0l.46-.24h0c0,.08,0,.2-.16.27s-.26.05-.3,0h0l.46-.24h0v0a.25.25,0,0,1,0,.07A.39.39,0,0,1,69.62,243.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,364c-.13.07-14.73-28.49-32.61-63.76s-32.27-63.94-32.14-64S83.81,264.7,101.7,300,134,363.93,133.84,364Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,384.49c-.12,22.4-.2,58.57-.24,75.19a8.88,8.88,0,0,0,8.85,8.9l61.19.28a8.9,8.9,0,0,0,8.93-8.85l.34-74.53a19.75,19.75,0,0,0-19.65-19.83h0l0-11-40.07-.18,0,10.36h-.15A19.73,19.73,0,0,0,36.91,384.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.31 355.9 56.28 360.89 96.34 362.49 96.38 356.08 56.31 355.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73,339.31H98.18a3,3,0,0,1,3,3v15a1.93,1.93,0,0,1-1.93,1.93H53.67a1.93,1.93,0,0,1-1.93-1.93v-15a3,3,0,0,1,3-3Z",
    transform: "translate(1.59 -0.35) rotate(0.26)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,359.19c-.29,0-.51-4.44-.48-9.9s.28-9.9.57-9.9.51,4.43.48,9.9S58.31,359.19,58,359.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3,359.21c-.29,0-.51-4.43-.48-9.9s.28-9.9.57-9.9.51,4.44.48,9.91S63.59,359.21,63.3,359.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.58,359.24c-.29,0-.51-4.44-.48-9.9s.28-9.9.57-9.9.51,4.43.48,9.9S68.87,359.24,68.58,359.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,359.26c-.29,0-.51-4.43-.48-9.9s.28-9.9.57-9.9.51,4.44.48,9.9S74.15,359.26,73.86,359.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.14,359.29c-.29,0-.51-4.44-.48-9.91s.28-9.9.57-9.89.51,4.43.48,9.9S79.43,359.29,79.14,359.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.42,359.31c-.29,0-.51-4.44-.48-9.9s.28-9.9.57-9.9.51,4.43.48,9.9S84.71,359.31,84.42,359.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7,359.33c-.29,0-.51-4.43-.48-9.9s.28-9.9.57-9.9.51,4.44.48,9.91S90,359.34,89.7,359.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,359.36c-.29,0-.51-4.44-.48-9.9s.28-9.9.57-9.9.51,4.43.48,9.9S95.27,359.36,95,359.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.97,
    y: 395.46,
    width: 57.41,
    height: 37.97,
    rx: 1.48,
    transform: "translate(1.89 -0.35) rotate(0.26)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.46,430.94a3.41,3.41,0,0,1,0-.63c0-.47,0-1.06,0-1.77,0-1.63,0-3.86-.07-6.66,0-5.8-.07-14-.11-23.9l.41.42-50.31-.12.52-.52h0v4.35c0,1.45,0,2.88,0,4.31,0,2.85,0,5.66-.05,8.42,0,5.51-.07,10.82-.1,15.87l-.48-.49,36.1.4,10.41.18,2.8.07,1,.06a4.85,4.85,0,0,1-.9.06l-2.7,0-10.3.09-36.43.07h-.48v-.49c0-5,0-10.35,0-15.87,0-2.76,0-5.56,0-8.42,0-1.42,0-2.86,0-4.31v-4.35h0c-.47.47.64-.64.53-.52l50.32.33H102V398c-.13,10-.25,18.3-.33,24.16,0,2.76-.1,5-.13,6.57,0,.68,0,1.23-.06,1.69A2.42,2.42,0,0,1,101.46,430.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,408.61c0,.3-7.66.5-17.1.45s-17.1-.31-17.1-.6,7.66-.49,17.11-.45S93.77,408.32,93.77,408.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,414.43c0,.29-7.65.49-17.1.45s-17.09-.32-17.09-.61,7.65-.49,17.1-.45S93.75,414.14,93.74,414.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.72,420c0,.29-7.66.49-17.1.45s-17.1-.31-17.1-.6,7.66-.49,17.1-.45S93.72,419.72,93.72,420Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,365.3c0,.29-8.35.48-18.66.44s-18.66-.32-18.66-.61,8.36-.49,18.67-.44S94,365,94,365.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,455.38a20.76,20.76,0,0,1-.18-3.53c0-2.45-.06-5.69-.1-9.62,0-8.12,0-19.34.09-31.73.06-6.19.12-12.08.17-17.47s.59-10.35,2.38-14.13a15.51,15.51,0,0,1,6.38-7.22,11.15,11.15,0,0,1,2.46-1,3.34,3.34,0,0,1,.92-.13A22.83,22.83,0,0,0,49,372,15.67,15.67,0,0,0,43,379.2C41.41,382.86,41,387.7,41,393s-.06,11.28-.09,17.47c-.09,12.39-.24,23.61-.39,31.72-.1,3.93-.18,7.18-.24,9.62A23.36,23.36,0,0,1,40,455.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82,466a16.2,16.2,0,0,1-2.75-.87c-.86-.32-1.92-.7-3.18-1.07s-2.66-.88-4.26-1.27a98,98,0,0,0-11.29-2.42,106.76,106.76,0,0,0-14.09-1.1,104.39,104.39,0,0,0-14.1,1,98.65,98.65,0,0,0-11.32,2.31c-1.6.38-3,.86-4.27,1.23s-2.32.73-3.19,1.05a15.37,15.37,0,0,1-2.75.84,14.84,14.84,0,0,1,2.6-1.23c.85-.37,1.9-.8,3.15-1.21s2.65-1,4.26-1.4A87,87,0,0,1,63,459.33a98.11,98.11,0,0,1,14.24-1.07,97.32,97.32,0,0,1,14.24,1.19,88.83,88.83,0,0,1,11.35,2.66c1.6.44,3,1,4.24,1.43s2.3.87,3.14,1.25A14.68,14.68,0,0,1,112.82,466Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.08,146.41c-1.13-6.61-7.05-12.55-13.74-12.25a14.76,14.76,0,0,0-10.2,5.44,26.84,26.84,0,0,0-2.49,3.26,27.18,27.18,0,0,0-2.15-3.5,14.63,14.63,0,0,0-9.56-6.48c-6.63-1-13.13,4.27-15,10.72s.28,13.51,4,19.07,10.09,12.77,21.31,16c7.57-1.33,17.46-8.56,21.77-13.69S475.21,153,474.08,146.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.22,158.46h-.87l-2.49-.09-9.15-.41.16-.11c-1,2.91-2.1,6.33-3.34,10.07l-.2.61-.18-.62c-1.38-4.75-2.92-10.07-4.55-15.67-.5-1.74-1-3.45-1.48-5.11l.39.05L444,157.07l-.06.09h-.11l-16.09-.93-4.56-.3-1.2-.09a3.37,3.37,0,0,1-.41-.05s.14,0,.41,0l1.21,0,4.56.18,16.1.77-.18.09,6.48-9.9.26-.4.13.45c.48,1.67,1,3.38,1.48,5.12,1.61,5.61,3.15,10.93,4.51,15.68h-.38l3.42-10,0-.12h.12l9.14.55,2.48.18.65,0A.86.86,0,0,1,472.22,158.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.29,181.23a2.75,2.75,0,0,1,.39-.28l1.17-.77a18.19,18.19,0,0,0,1.86-1.3,29.43,29.43,0,0,0,2.42-1.93l1.38-1.22c.46-.45.94-.94,1.43-1.44a21.63,21.63,0,0,0,1.5-1.63c.49-.59,1.05-1.17,1.52-1.85a43,43,0,0,0,5.7-9.63A42.52,42.52,0,0,0,383,148.06a41.42,41.42,0,0,0,0-7.55,75.59,75.59,0,0,0-1.37-7.92c-1.14-5.36-2.65-11.1-2.19-17.19s2.88-12,6.1-17.53,7-10.6,11.71-14.46a28.94,28.94,0,0,1,7.62-4.58,33.38,33.38,0,0,1,8.27-2,100.3,100.3,0,0,1,15.7-.25A71.59,71.59,0,0,0,442.39,76a27.24,27.24,0,0,0,10.46-3.76A20.56,20.56,0,0,0,459,66.46a15.15,15.15,0,0,0,2.26-4.82c.31-1.18.37-1.83.41-1.82a10.55,10.55,0,0,1-.3,1.85,14.72,14.72,0,0,1-2.19,4.91,20.53,20.53,0,0,1-6.12,5.9,27.39,27.39,0,0,1-10.57,3.88,70.52,70.52,0,0,1-13.66.63,103.15,103.15,0,0,0-15.62.3,33.51,33.51,0,0,0-8.14,2,28.47,28.47,0,0,0-7.47,4.51c-4.62,3.79-8.35,8.86-11.58,14.31s-5.58,11.33-6,17.29,1,11.66,2.15,17.05a75,75,0,0,1,1.35,8,40.7,40.7,0,0,1,0,7.65A42.88,42.88,0,0,1,380,161.34a43.65,43.65,0,0,1-5.82,9.67c-.49.68-1,1.25-1.55,1.84s-1,1.14-1.52,1.63l-1.46,1.43-1.41,1.21a28.59,28.59,0,0,1-2.46,1.9,17.1,17.1,0,0,1-1.9,1.26l-1.2.72A2.42,2.42,0,0,1,362.29,181.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.11,154.18s.06-.16.2-.45.37-.75.64-1.3.71-1.23,1.18-2,1.08-1.69,1.84-2.63a36.74,36.74,0,0,1,6.14-6.29,37.16,37.16,0,0,1,10.06-5.83,38.62,38.62,0,0,1,6.54-1.83,49.17,49.17,0,0,1,7.33-.67c5.07-.15,10.49.27,16.15-.07a39.31,39.31,0,0,0,8.55-1.44,37.29,37.29,0,0,0,8.29-3.59,42,42,0,0,0,13.69-13,47.61,47.61,0,0,0,7-17.62,57.56,57.56,0,0,0,.48-17.71c-.71-5.63-2.08-10.88-2.87-15.9a40.37,40.37,0,0,1-.2-14.09A30.12,30.12,0,0,1,424.51,39a30.79,30.79,0,0,1,5.8-6.6,32.09,32.09,0,0,1,4.56-3.17l1.29-.65.45-.2-.42.25-1.26.7a33.45,33.45,0,0,0-4.48,3.24,31.08,31.08,0,0,0-5.68,6.6,30.25,30.25,0,0,0-4.27,10.66,40.36,40.36,0,0,0,.27,13.94c.8,5,2.19,10.23,2.93,15.91a58,58,0,0,1-.46,17.88,47.88,47.88,0,0,1-7.05,17.82,42.4,42.4,0,0,1-13.88,13.18,37.92,37.92,0,0,1-8.42,3.63,39.3,39.3,0,0,1-8.66,1.45c-5.72.33-11.13-.11-16.18,0a49.38,49.38,0,0,0-7.26.64,38.16,38.16,0,0,0-6.48,1.77,37.81,37.81,0,0,0-16.17,11.89c-.76.92-1.33,1.83-1.87,2.58s-.91,1.45-1.22,2-.52,1-.69,1.26S335.11,154.18,335.11,154.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.18,38.66a10.3,10.3,0,0,1,1.54.89c1,.6,2.34,1.51,4,2.67A154.7,154.7,0,0,1,453.89,63c1.39,1.49,2.5,2.71,3.24,3.58A10.5,10.5,0,0,1,458.24,68,11.59,11.59,0,0,1,457,66.74c-.87-.88-2-2-3.37-3.46-2.86-2.9-6.91-6.81-11.62-10.86s-9.17-7.48-12.47-9.87l-3.92-2.82A11.09,11.09,0,0,1,424.18,38.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.23,49.34a9.75,9.75,0,0,1,1.14,1l3,2.88c2.53,2.43,6.07,5.73,10.12,9.23s7.83,6.51,10.61,8.66l3.28,2.54a8.34,8.34,0,0,1,1.18,1,7.89,7.89,0,0,1-1.3-.8c-.82-.55-2-1.37-3.4-2.4-2.84-2.07-6.68-5-10.74-8.55s-7.57-6.87-10-9.37c-1.23-1.26-2.21-2.29-2.87-3A7,7,0,0,1,420.23,49.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.55,62.45a17.73,17.73,0,0,1,2.57,1.89c1.54,1.22,3.63,3,5.89,5s4.25,3.85,5.66,5.22a16.3,16.3,0,0,1,2.2,2.32,19.93,19.93,0,0,1-2.47-2l-5.76-5.08-5.77-5.08A18,18,0,0,1,421.55,62.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.62,78.19a11.31,11.31,0,0,1,1.95,1.43l4.55,3.63,4.6,3.58a10.51,10.51,0,0,1,1.85,1.57,10.13,10.13,0,0,1-2.08-1.25c-1.24-.83-2.92-2-4.71-3.45s-3.37-2.76-4.47-3.77A9.55,9.55,0,0,1,411.62,78.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,83c.06-.06,1.24,1.09,3.2,2.87S407.75,90,411,92.45s6.27,4.48,8.51,5.9a42.52,42.52,0,0,1,3.61,2.32,5.28,5.28,0,0,1-1.06-.47c-.66-.33-1.61-.85-2.76-1.51a87.74,87.74,0,0,1-8.64-5.79,84.54,84.54,0,0,1-7.87-6.79c-.95-.93-1.7-1.71-2.19-2.26A4.14,4.14,0,0,1,399.83,83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.35,91.91c.09-.13,5.92,4.18,13,9.62s12.76,9.94,12.66,10.06-5.91-4.18-13-9.62S392.26,92,392.35,91.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3,100a6.41,6.41,0,0,1,1.13.82l3,2.37c2.52,2,6,4.76,9.94,7.71s7.54,5.53,10.17,7.38l3.12,2.21a6.61,6.61,0,0,1,1.1.86,7,7,0,0,1-1.22-.68c-.78-.47-1.88-1.17-3.22-2.06-2.69-1.77-6.36-4.31-10.29-7.26s-7.4-5.76-9.85-7.85c-1.23-1-2.21-1.9-2.88-2.51A6.48,6.48,0,0,1,383.3,100Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.56,111.72c.09-.13,5,3.53,11.05,8.16s10.8,8.49,10.7,8.61-5-3.53-11.05-8.16S380.46,111.84,380.56,111.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,123.91a51.75,51.75,0,0,1,6.43,4,52.07,52.07,0,0,1,6.13,4.43,50,50,0,0,1-6.44-4A49.16,49.16,0,0,1,378,123.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33,135.57a19.06,19.06,0,0,1,2.89,1.64c1.74,1.09,4.11,2.65,6.65,4.47s4.79,3.57,6.37,4.86a17.15,17.15,0,0,1,2.48,2.22,21.72,21.72,0,0,1-2.72-1.9c-1.65-1.22-3.92-2.9-6.46-4.72s-4.85-3.43-6.53-4.6A19.91,19.91,0,0,1,365.33,135.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.31,135.78a6.16,6.16,0,0,1,1.16.79c.73.54,1.76,1.35,3,2.36,2.52,2,5.94,4.9,9.59,8.22s6.83,6.46,9.08,8.78c1.13,1.16,2,2.12,2.63,2.79a6.89,6.89,0,0,1,.89,1.08,6.58,6.58,0,0,1-1.05-.93l-2.75-2.65c-2.32-2.25-5.54-5.33-9.18-8.65s-7-6.24-9.46-8.34l-2.9-2.49A6.85,6.85,0,0,1,354.31,135.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,144a8.33,8.33,0,0,1,1.26.88c.78.6,1.9,1.47,3.27,2.57,2.75,2.2,6.5,5.29,10.57,8.79s7.7,6.73,10.29,9.11c1.3,1.19,2.33,2.17,3,2.85a7.61,7.61,0,0,1,1.06,1.11,8.92,8.92,0,0,1-1.21-.95l-3.15-2.71c-2.74-2.37-6.38-5.51-10.39-9l-10.46-8.9L346.18,145A8.16,8.16,0,0,1,345.06,144Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,42a15.14,15.14,0,0,1,5.46,10.51A26.69,26.69,0,0,1,331,64.44c-2.74,7.37-9,13.94-15.1,18.84-5-7.15-4-17.24-3.24-22.32,1.27-8,8.45-21.79,14.78-19",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,97.64a12.91,12.91,0,0,1,7-10.9A17.13,17.13,0,0,1,340.41,86c2,.66,4,1.8,4.79,3.76a5.54,5.54,0,0,1-1.27,5.45,11.25,11.25,0,0,1-5,3c-6.39,2.09-13,2.94-18.75-.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,113.29a25.44,25.44,0,0,1,2.1-4.76,24.23,24.23,0,0,1,3.21-4.68,53.16,53.16,0,0,1,4.75-5,25.86,25.86,0,0,1,11-6,19.22,19.22,0,0,1,3.8-.49,4.05,4.05,0,0,1,1.4.12c0,.16-2,.11-5,1a27.8,27.8,0,0,0-10.58,6.1,61.32,61.32,0,0,0-4.73,4.92,27.07,27.07,0,0,0-3.28,4.46A38.48,38.48,0,0,1,308.25,113.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.87,53a15.08,15.08,0,0,1-.38,2.6c-.3,1.67-.77,4.07-1.37,7-1.21,5.92-3,14.08-5.12,23s-4.36,17-6.06,22.83c-.85,2.9-1.57,5.24-2.1,6.84a14.09,14.09,0,0,1-.9,2.47,14.93,14.93,0,0,1,.57-2.56c.47-1.79,1.09-4.12,1.83-6.92,1.55-5.84,3.64-13.91,5.8-22.87l5.37-23c.67-2.82,1.22-5.16,1.64-7A15.47,15.47,0,0,1,322.87,53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.81,98.15A30.21,30.21,0,0,0,295.76,74.4c-2.07-1.28-4.85-2.27-6.82-.83s-1.88,4.4-1.24,6.75a25.77,25.77,0,0,0,21.89,18.45",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.57,81.49s.45.23,1.15.76,1.7,1.36,2.89,2.41a34.28,34.28,0,0,1,7.69,9.76,21.36,21.36,0,0,1,2,6.6,20.74,20.74,0,0,1-.1,5.63,20.3,20.3,0,0,1-.92,3.67,4.6,4.6,0,0,1-.54,1.27c-.17,0,.48-1.91.84-5a22.31,22.31,0,0,0-.09-5.44,21.72,21.72,0,0,0-2-6.32,38.57,38.57,0,0,0-7.33-9.7A43.08,43.08,0,0,1,296.57,81.49Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.23,
    y: 104.33,
    width: 255.05,
    height: 366.02,
    rx: 11.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.15,
    y: 130.44,
    width: 238.96,
    height: 305.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,452a9.79,9.79,0,1,1-9.78-9.79A9.78,9.78,0,0,1,245.54,452Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.35,
    y: 114.87,
    width: 76.82,
    height: 4.04,
    rx: 1.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.92,
    y: 154.32,
    width: 190.37,
    height: 32.14,
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,165.38h1.44v10.1h-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,165.38v10.1h-1.18L207,168v7.53h-1.44v-10.1h1.18l6.07,7.53v-7.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,174.33l.53-1.13a5.2,5.2,0,0,0,3.34,1.17c1.74,0,2.49-.68,2.49-1.56,0-2.47-6.12-.91-6.12-4.66,0-1.56,1.22-2.89,3.87-2.89a5.92,5.92,0,0,1,3.25.9l-.48,1.15a5.22,5.22,0,0,0-2.77-.82c-1.72,0-2.45.72-2.45,1.6,0,2.47,6.12.92,6.12,4.63,0,1.55-1.24,2.88-3.91,2.88A6,6,0,0,1,216.36,174.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16,171.12v-5.74h1.44v5.68c0,2.24,1,3.25,2.85,3.25s2.85-1,2.85-3.25v-5.68h1.41v5.74c0,2.93-1.61,4.48-4.28,4.48S226.16,174.05,226.16,171.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42,175.48l-2.18-3.1-.63,0h-2.5v3.07h-1.45v-10.1h4c2.62,0,4.21,1.32,4.21,3.52a3.19,3.19,0,0,1-2.22,3.19l2.39,3.39Zm0-6.58c0-1.44-1-2.27-2.82-2.27h-2.45v4.55h2.45C243.41,171.18,244.38,170.34,244.38,168.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,173h-5.37l-1.12,2.53h-1.48l4.57-10.1h1.43l4.59,10.1h-1.51Zm-.51-1.15-2.18-5-2.18,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,165.38v10.1h-1.18L260.17,168v7.53h-1.44v-10.1h1.18l6.06,7.53v-7.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,170.43a5.11,5.11,0,0,1,5.36-5.17,5,5,0,0,1,3.84,1.57l-.94.91a3.74,3.74,0,0,0-2.84-1.19,3.88,3.88,0,1,0,0,7.76,3.76,3.76,0,0,0,2.84-1.21l.94.91A5,5,0,0,1,275,175.6,5.11,5.11,0,0,1,269.62,170.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,174.22v1.26h-7.34v-10.1H288v1.25h-5.68v3.11h5.06V171h-5.06v3.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,228.79s0-.18,0-.54,0-.91,0-1.63c0-1.46,0-3.67-.05-6.69l.08.08c-23.67.11-102.09.18-195,.18h0l.26-.26v8.86l-.26-.26,138.15.11,41.61.08,11.31,0,2.94,0,1,0-1,0-2.91,0-11.25,0-41.55.08-138.34.11h-.26v-9.38h.27c92.93,0,171.35.08,195,.19H338v.07c0,3,0,5.26,0,6.73,0,.72,0,1.25,0,1.61S338,228.79,338,228.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,207.91c0,.15-8.57.26-19.14.26s-19.14-.11-19.14-.26,8.57-.26,19.14-.26S178.35,207.77,178.35,207.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,364.23s0-.19,0-.55,0-.9,0-1.63c0-1.46,0-3.66,0-6.68l.07.07c-23.67.11-102.08.19-195,.19h0l.26-.26v8.86l-.26-.26,138.14.1,41.62.08,11.3,0,2.95,0c.66,0,1,0,1,0h-1l-2.92,0-11.24,0-41.55.08-138.34.11h-.26v-9.38h.27c92.93,0,171.34.08,195,.19h.08v.07c0,3,0,5.25-.05,6.73,0,.71,0,1.24,0,1.61S335.09,364.23,335.09,364.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,346.46c0,.15-8.57.26-19.14.26s-19.14-.11-19.14-.26,8.57-.26,19.14-.26S180.07,346.32,180.07,346.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,262.64s0-.18,0-.54,0-.9,0-1.63c0-1.46,0-3.66,0-6.68l.07.07c-23.67.11-102.08.19-195,.19h0l.26-.26v8.85l-.26-.26,138.14.11,41.62.08,11.3,0,2.95,0h1s-.32,0-1,0l-2.92,0-11.24,0-41.55.08-138.34.1h-.26v-9.37h.27c92.93,0,171.34.08,195,.19h.08v.07c0,3,0,5.25-.05,6.72,0,.72,0,1.25,0,1.62S335.09,262.64,335.09,262.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,244.88c0,.15-8.57.26-19.14.26s-19.14-.11-19.14-.26,8.57-.26,19.14-.26S178.35,244.74,178.35,244.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,296.5s0-.21,0-.59,0-1,0-1.71c0-1.51,0-3.71-.06-6.56l.11.11c-14.41.09-46.15.15-82.94.15h0c.12-.11-.26.26.26-.26h0v8.83l-.26-.26,58.86.11,17.61.08,4.78,0,1.25,0,.44,0-.41,0h-1.21l-4.72,0-17.56.08-59,.11h-.26v-9.09h0l.26-.26h0c36.79,0,68.53.06,82.94.15h.11v.11c0,2.88-.05,5.1-.07,6.62,0,.73,0,1.29,0,1.69S223,296.5,223,296.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,278.74c0,.14-8.57.26-19.14.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26S178.35,278.59,178.35,278.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,328.69a4.62,4.62,0,0,1,0-.66c0-.48,0-1.08-.05-1.8,0-1.61-.07-3.78-.11-6.39l.2.2-13.8.06c-.06,0,.49-.5.26-.26h0v2.31c0,.77,0,1.52,0,2.26,0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a9.68,9.68,0,0,1,1.06.05,5.39,5.39,0,0,1-1,.06l-2.82.06c-2.43.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0l.26-.26,13.8.05h.21v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.23,2.23,0,0,1,153.87,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,328.69a4.62,4.62,0,0,1,0-.66q0-.72-.06-1.8c0-1.61-.06-3.78-.11-6.39l.21.2-13.8.06c-.06,0,.49-.5.26-.26h0V321c0,.39,0,.77,0,1.15v2.26c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.86.12l2.87.07a9.78,9.78,0,0,1,1.07.05,5.53,5.53,0,0,1-1,.06l-2.82.06c-2.43.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0c-.24.23.31-.32.26-.26l13.8.05h.21v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28,0,1.75A2.23,2.23,0,0,1,172.1,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.33,328.69a3.71,3.71,0,0,1-.05-.66c0-.48,0-1.08-.05-1.8,0-1.61-.06-3.78-.11-6.39l.21.2-13.81.06.26-.26h0v4.57c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.43.07,9.87.12l2.87.07a10,10,0,0,1,1.07.05,5.6,5.6,0,0,1-1,.06l-2.81.06c-2.43.05-5.92.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27,0-.74,0-1.49,0-2.26v-2.31h0l.26-.26,13.81.05h.21v.21c0,2.75-.07,5-.1,6.52,0,.7,0,1.28-.06,1.75A2.77,2.77,0,0,1,190.33,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,328.69s0-.24,0-.66,0-1.08,0-1.8c0-1.61-.07-3.78-.11-6.39l.2.2-13.8.06c-.06,0,.49-.5.26-.26h0v2.31c0,.77,0,1.52,0,2.26,0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a9.46,9.46,0,0,1,1.06.05,5.39,5.39,0,0,1-1,.06l-2.82.06c-2.42.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0l.26-.26,13.8.05h.21v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.23,2.23,0,0,1,208.55,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,328.69a4.62,4.62,0,0,1,0-.66c0-.48,0-1.08-.06-1.8,0-1.61-.06-3.78-.1-6.39l.2.2-13.8.06c-.06,0,.49-.5.26-.26h0v2.31c0,.77,0,1.52,0,2.26,0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.86.12l2.87.07a9.78,9.78,0,0,1,1.07.05,5.53,5.53,0,0,1-1,.06l-2.82.06c-2.43.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0l.26-.26,13.8.05H227v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28,0,1.75A2.23,2.23,0,0,1,226.78,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,328.69a3.71,3.71,0,0,1,0-.66c0-.48,0-1.08-.05-1.8,0-1.61-.06-3.78-.11-6.39l.21.2-13.81.06.26-.26h0v4.57c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.43.07,9.87.12l2.87.07a9.78,9.78,0,0,1,1.07.05,5.6,5.6,0,0,1-1,.06l-2.81.06c-2.43.05-5.92.1-10,.12H231v-.24c0-1.36,0-2.79,0-4.27,0-.74,0-1.49,0-2.26v-2.31h0l.26-.26,13.81.05h.21v.21c0,2.75-.07,5-.1,6.52,0,.7,0,1.28-.06,1.75A2.77,2.77,0,0,1,245,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,328.69a3.71,3.71,0,0,1-.05-.66c0-.48,0-1.08-.05-1.8,0-1.61-.07-3.78-.11-6.39l.21.2-13.81.06c-.06,0,.49-.5.26-.26h0v4.57c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a10,10,0,0,1,1.07.05,5.74,5.74,0,0,1-1,.06l-2.81.06c-2.43.05-5.92.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27,0-.74,0-1.49,0-2.26v-2.31h0l.26-.26,13.81.05h.2v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.77,2.77,0,0,1,263.24,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.46,328.69a4.62,4.62,0,0,1,0-.66c0-.48,0-1.08-.05-1.8,0-1.61-.07-3.78-.11-6.39l.2.2-13.8.06c-.06,0,.49-.5.26-.26h0v2.31c0,.77,0,1.52,0,2.26,0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a9.68,9.68,0,0,1,1.06.05,5.53,5.53,0,0,1-1,.06l-2.82.06c-2.43.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0c-.24.23.31-.32.26-.26l13.8.05h.21v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.23,2.23,0,0,1,281.46,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,328.69a5.46,5.46,0,0,1-.05-.66c0-.48,0-1.08-.05-1.8,0-1.61-.06-3.78-.11-6.39l.21.2-13.8.06c-.06,0,.49-.5.25-.26h0v4.57c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.43.07,9.87.12l2.87.07a9.78,9.78,0,0,1,1.07.05,5.53,5.53,0,0,1-1,.06l-2.82.06c-2.43.05-5.92.1-10,.12h-.23v-.24c0-1.36,0-2.79,0-4.27v-2.26c0-.38,0-.76,0-1.15v-1.16h0c-.23.23.32-.32.27-.26l13.8.05h.21v.21c0,2.75-.08,5-.11,6.52,0,.7,0,1.28-.06,1.75A2.77,2.77,0,0,1,299.69,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,328.69a3.71,3.71,0,0,1-.05-.66c0-.48,0-1.08-.05-1.8,0-1.61-.06-3.78-.11-6.39l.21.2-13.81.06c-.06,0,.49-.5.26-.26h0v4.57c0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a10,10,0,0,1,1.07.05,5.6,5.6,0,0,1-1,.06l-2.81.06c-2.43.05-5.92.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27,0-.74,0-1.49,0-2.26v-2.31h0l.26-.26,13.81.05h.2v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.77,2.77,0,0,1,317.92,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,328.69a4.62,4.62,0,0,1,0-.66c0-.48,0-1.08-.05-1.8,0-1.61-.07-3.78-.11-6.39l.2.2-13.8.06c-.06,0,.49-.5.26-.26h0v2.31c0,.77,0,1.52,0,2.26,0,1.48,0,2.91,0,4.27l-.24-.24c4,0,7.42.07,9.87.12l2.87.07a9.68,9.68,0,0,1,1.06.05,5.39,5.39,0,0,1-1,.06l-2.82.06c-2.43.05-5.91.1-10,.12h-.24v-.24c0-1.36,0-2.79,0-4.27v-4.57h0l.26-.26,13.8.05h.21v.21c0,2.75-.07,5-.11,6.52,0,.7,0,1.28-.05,1.75A2.23,2.23,0,0,1,336.14,328.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,310.93c0,.15-8.57.26-19.14.26s-19.14-.11-19.14-.26,8.57-.26,19.14-.26S180.07,310.79,180.07,310.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.71,296.5s0-.21,0-.59,0-1,0-1.71c0-1.51,0-3.71-.06-6.56l.11.11c-14.41.09-46.14.15-82.93.15h0l.26-.26h0v8.83l-.26-.26,58.86.11,17.61.08,4.79,0,1.25,0,.43,0-.4,0h-1.22l-4.72,0-17.55.08-59,.11h-.25v-.26c0-1.41,0-2.87,0-4.35v-4.48h0l.27-.26h0c36.79,0,68.52.06,82.93.15h.11v.11c0,2.88-.05,5.1-.06,6.62,0,.73,0,1.29,0,1.69S333.71,296.5,333.71,296.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,278.74c0,.14-8.57.26-19.14.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26S290.78,278.59,290.78,278.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,410.33h-74A12.67,12.67,0,0,1,186,397.66h0A12.67,12.67,0,0,1,198.64,385h74a12.67,12.67,0,0,1,12.67,12.67h0A12.67,12.67,0,0,1,272.65,410.33Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.31,
    y: 164.74,
    width: 2.5,
    height: 11.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.31,
    y: 164.74,
    width: 2.5,
    height: 11.2,
    transform: "translate(3.22 343.9) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.87,170.37s0-.05,0-.15l0-.45,0-.32a3.1,3.1,0,0,0-.06-.39,5.78,5.78,0,0,0-.19-1,9.37,9.37,0,0,0-7.3-6.83,9.51,9.51,0,0,0-6.07.94,9.06,9.06,0,0,0-1.13.73,9.88,9.88,0,0,0-1,.89,11.67,11.67,0,0,0-.91,1.07,9.08,9.08,0,0,0-1.32,2.55,9.27,9.27,0,0,0,0,5.83,8.82,8.82,0,0,0,1.32,2.55,10.47,10.47,0,0,0,.91,1.07,8.83,8.83,0,0,0,1,.89,9.06,9.06,0,0,0,1.13.73,8.08,8.08,0,0,0,1.21.53,9.26,9.26,0,0,0,11.12-3.94,9.12,9.12,0,0,0,1-2.47,6,6,0,0,0,.19-1,3.1,3.1,0,0,0,.06-.39l0-.33,0-.44c0-.1,0-.15,0-.15v.15c0,.11,0,.26,0,.44l0,.33c0,.12,0,.25-.05.4a7.28,7.28,0,0,1-.18,1,9,9,0,0,1-1,2.51,9.36,9.36,0,0,1-6.32,4.45,9.56,9.56,0,0,1-5-.39,12.09,12.09,0,0,1-1.23-.54,11.94,11.94,0,0,1-1.16-.74,13.19,13.19,0,0,1-1.07-.91,10.61,10.61,0,0,1-.92-1.09,8.81,8.81,0,0,1-1.35-2.6,9.31,9.31,0,0,1,0-6,8.81,8.81,0,0,1,1.35-2.6,10.81,10.81,0,0,1,.92-1.09,10.11,10.11,0,0,1,1.07-.91,8.83,8.83,0,0,1,2.39-1.28,9.34,9.34,0,0,1,8.91,1.38,9.27,9.27,0,0,1,2.37,2.68,9,9,0,0,1,1,2.51,7.28,7.28,0,0,1,.18,1c0,.14,0,.27.05.39l0,.33c0,.19,0,.34,0,.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,399.79h-3.4l-.65,1.57H220l3.26-7.33h1.68l3.27,7.33h-1.78Zm-.53-1.29-1.16-2.8-1.16,2.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,397.69a4,4,0,0,1,7-2.49l-1.09,1a2.34,2.34,0,0,0-1.84-.86,2.35,2.35,0,0,0,0,4.69,2.32,2.32,0,0,0,1.84-.87l1.09,1a4,4,0,0,1-7-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.91,397.69a3.77,3.77,0,0,1,4-3.78,3.82,3.82,0,0,1,3,1.29l-1.09,1a2.34,2.34,0,0,0-1.84-.86,2.35,2.35,0,1,0,0,4.69,2.32,2.32,0,0,0,1.84-.87l1.09,1a4,4,0,0,1-7-2.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.72,400v1.36H244V394h5.54v1.36h-3.85V397h3.4v1.32h-3.4V400Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,396.69c0,1.63-1.22,2.65-3.18,2.65h-1.48v2h-1.69V394h3.17C256.2,394,257.42,395.05,257.42,396.69Zm-1.72,0c0-.81-.52-1.28-1.56-1.28h-1.38V398h1.38C255.18,398,255.7,397.49,255.7,396.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.94,395.41H257.6V394H264v1.38h-2.34v5.95h-1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.23 397.84 204.49 396.58 206.92 398.74 211.69 394.15 212.86 395.41 206.74 401.17 203.23 397.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.31,469.71c0,.14-97.75.26-218.3.26s-218.32-.12-218.32-.26,97.73-.26,218.32-.26S465.31,469.56,465.31,469.71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.28,444.41l-1,16.68s16.61,6.65,16.72,9.75L406.56,470,407.1,444Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.27,459.43a1.33,1.33,0,0,0-.95,1.49,1.27,1.27,0,0,0,1.46,1,1.39,1.39,0,0,0,1-1.58,1.32,1.32,0,0,0-1.63-.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.56,470l.16-2.62,31,1.77s1.43.67,1.24,1.68Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,460.94c0,.16-.8.21-1.6.7s-1.22,1.14-1.36,1.08.11-1,1.08-1.55S422.83,460.8,422.79,460.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,462.43c0,.16-.66.41-1.21,1.07s-.73,1.36-.89,1.35-.23-.91.47-1.72S426.15,462.28,426.15,462.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,466.55c-.15,0-.35-.76.08-1.62s1.18-1.18,1.24-1.05-.4.59-.74,1.29S428.14,466.54,428,466.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.6,457.11c-.07.15-.79-.09-1.69-.05s-1.6.3-1.68.16.61-.68,1.67-.71S422.68,457,422.6,457.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "423.08 447.71 422.9 450.69 406.97 450.14 407.03 446.7 423.08 447.71"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,453.74a2.94,2.94,0,0,1-1.62-.05,6.74,6.74,0,0,1-1.68-.56,6.52,6.52,0,0,1-.92-.52,1.83,1.83,0,0,1-.48-.39.7.7,0,0,1-.06-.85.9.9,0,0,1,.71-.34,2,2,0,0,1,.6.1,5.61,5.61,0,0,1,1,.37,5.89,5.89,0,0,1,1.48,1c.73.72,1,1.31.92,1.34s-.43-.45-1.18-1a6.14,6.14,0,0,0-1.43-.86,5.84,5.84,0,0,0-.92-.31c-.34-.1-.63-.11-.73,0s0,.08,0,.19a2,2,0,0,0,.36.28,7.66,7.66,0,0,0,.84.52,9.38,9.38,0,0,0,1.56.64A12,12,0,0,1,422.74,453.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53,454a2.75,2.75,0,0,1-.39-1.58,5.41,5.41,0,0,1,.27-1.77,5,5,0,0,1,.44-1,1.32,1.32,0,0,1,1.06-.79.73.73,0,0,1,.66.47,2.11,2.11,0,0,1,.15.6,3.6,3.6,0,0,1,0,1.09,3.75,3.75,0,0,1-.74,1.66c-.65.82-1.32,1-1.33.94s.51-.37,1-1.17a3.75,3.75,0,0,0,.56-1.51,3.3,3.3,0,0,0,0-.94c0-.34-.16-.62-.29-.59s-.45.24-.59.52a5.67,5.67,0,0,0-.42.86,6,6,0,0,0-.36,1.62C422.47,453.35,422.62,453.94,422.53,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,342.8l-25.77,8.28c.31.23,4.78,29.19,4.78,29.19l-3.72,76.88,20.45.25,9.15-80.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,444.35l-.52,16.7s16.8,6.14,17,9.24l-32.43.15-.26-26.06Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.48,459.7a1.33,1.33,0,0,0-.91,1.51,1.28,1.28,0,0,0,1.5.92,1.4,1.4,0,0,0,.95-1.61,1.32,1.32,0,0,0-1.66-.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.1,470.44l.08-2.62,31.06.83s1.44.62,1.29,1.64Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394,460.89c0,.15-.8.23-1.57.74s-1.19,1.18-1.34,1.12.09-1,1-1.58S394.07,460.74,394,460.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,462.28c0,.15-.65.42-1.18,1.09s-.69,1.39-.85,1.38-.26-.9.42-1.72S397.44,462.13,397.45,462.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4,466.34c-.14,0-.37-.76,0-1.63s1.15-1.21,1.21-1.08-.38.59-.7,1.31S399.56,466.32,399.4,466.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,457.07c-.07.14-.8-.07-1.69,0s-1.59.35-1.68.22.59-.71,1.64-.77S393.81,456.94,393.74,457.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.93 447.66 393.84 450.63 377.9 450.57 377.86 447.13 393.93 447.66"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,453.69a2.93,2.93,0,0,1-1.62,0,7.17,7.17,0,0,1-1.71-.51,9.31,9.31,0,0,1-.93-.49,2,2,0,0,1-.49-.38.68.68,0,0,1-.08-.84.89.89,0,0,1,.69-.37,2.2,2.2,0,0,1,.61.08,6,6,0,0,1,1,.35,5.7,5.7,0,0,1,1.51,1c.75.69,1,1.28,1,1.31s-.44-.44-1.21-1a6.74,6.74,0,0,0-1.45-.81,6.45,6.45,0,0,0-.94-.28c-.34-.09-.63-.09-.72.06s0,.09,0,.19a1.4,1.4,0,0,0,.36.27,6.76,6.76,0,0,0,.86.49,8.17,8.17,0,0,0,1.57.59A14,14,0,0,1,393.78,453.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.57,453.92a2.6,2.6,0,0,1-.43-1.56,5.31,5.31,0,0,1,.21-1.78,5.19,5.19,0,0,1,.41-1,1.37,1.37,0,0,1,1-.83.77.77,0,0,1,.68.45,2.19,2.19,0,0,1,.17.6,3.63,3.63,0,0,1,0,1.09,3.69,3.69,0,0,1-.69,1.68c-.63.85-1.29,1-1.3,1a10.42,10.42,0,0,0,1-1.19,3.59,3.59,0,0,0,.5-1.53,3,3,0,0,0,0-.94c-.05-.34-.18-.62-.31-.59s-.44.26-.57.54a5.64,5.64,0,0,0-.39.88,5.53,5.53,0,0,0-.31,1.62C393.49,453.31,393.66,453.9,393.57,453.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,346.9c0,5.82,2.3,113.74,2.3,113.74L395,458.91l4-66.32,2.09-5.78,2.43-35.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.42,207c.26.35,15.42,24.41,15.42,24.41l17.05-17.84,8.72,12.59s-18.23,25.73-20.91,26.66-11.3-.53-11.3-.53l-12-15.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,236.91a6.89,6.89,0,0,1-.32-2.77,8.24,8.24,0,0,1,.19-2.78,7,7,0,0,1,.33,2.77A8.44,8.44,0,0,1,430,236.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.87,189l-2.62,6.47s-13.45,11.35-14.67,13.1,9.6,58.33,9.6,58.33-.7,83.13,0,83.13,10,3,29,1.57,22.53-3.32,22.53-3.32l-5.93-73.52-9.09-49.43-15.59-20.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,217.07s-2-9.59-1.83-9.89-4.48-11.63-4.48-11.63-1.56-5.19-1.56-5.17-21.19-3.58-21.19-3.58l-1,3.2,28.26,35.71,2.9,15.33,3-4.18Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.42,289.25l-4.6-55.31-3.77-21.59a23.46,23.46,0,0,0-3.39-8.64l-11-6.37a48.42,48.42,0,0,1-3.15-4.21l5.21,13.31,1.83,10.63,1.13,24.39h0l6,32.74,5.88,72,12.78-2.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.1 224.81 410.57 206.66 402.62 197.34 399.47 193.13 404.36 207.18 408.1 224.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.54 258.68 414.75 231.36 448.18 241.47 422.89 274.19 391.49 263.98 395.54 258.68",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.42,240.21a.83.83,0,1,1-.83-.83A.83.83,0,0,1,438.42,240.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.05,236.48a.83.83,0,1,1-.82-.83A.83.83,0,0,1,425.05,236.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.38,213.79c-.05,0,.36,1.78.93,4a37.61,37.61,0,0,0,1.12,3.9c.05,0-.37-1.78-.93-3.95S409.43,213.78,409.38,213.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.76,226.05a4.23,4.23,0,0,1-.3,2.31,2.84,2.84,0,0,1-1.73,1.58,3.15,3.15,0,0,1-3.05-.65,8,8,0,0,1-1.91-5.77,3.52,3.52,0,0,1,2.19-3,3.17,3.17,0,0,1,3.61,1.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57,222.1a2.77,2.77,0,0,0-.51-.73,3.65,3.65,0,0,0-.82-.64,3,3,0,0,0-1.33-.38,3.23,3.23,0,0,0-.81.08,2.67,2.67,0,0,0-.83.33,3.56,3.56,0,0,0-1.23,1.49,4.55,4.55,0,0,0-.41,2.09,8.41,8.41,0,0,0,.41,2.24,6.32,6.32,0,0,0,1.78,3,3,3,0,0,0,1.48.61,3.54,3.54,0,0,0,1.46-.13h0a2.11,2.11,0,0,0,.93-.51,3.44,3.44,0,0,0,.62-.72,4,4,0,0,0,.5-1.43,3.58,3.58,0,0,0,0-1,1.08,1.08,0,0,0,0-.25.66.66,0,0,0,0-.09,5.53,5.53,0,0,1-.05,1.29,3.89,3.89,0,0,1-.52,1.38,3.21,3.21,0,0,1-.61.68,2,2,0,0,1-.87.46h0a3.08,3.08,0,0,1-2.76-.48,6.22,6.22,0,0,1-1.71-2.87,5.84,5.84,0,0,1,0-4.2,3.4,3.4,0,0,1,1.15-1.42,2.43,2.43,0,0,1,.77-.32,2.84,2.84,0,0,1,2.06.25,3.28,3.28,0,0,1,.82.6A5.64,5.64,0,0,1,414.57,222.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,225.9a4.19,4.19,0,0,1-.3,2.3,2.85,2.85,0,0,1-1.73,1.59,3.15,3.15,0,0,1-3.05-.65,8,8,0,0,1-1.91-5.77,3.5,3.5,0,0,1,2.18-3,3.18,3.18,0,0,1,3.62,1.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.46,221.94a2.66,2.66,0,0,0-.51-.72,3.39,3.39,0,0,0-.82-.64,3,3,0,0,0-1.34-.38,2.86,2.86,0,0,0-.81.08,2.48,2.48,0,0,0-.82.33,3.44,3.44,0,0,0-1.23,1.49,4.48,4.48,0,0,0-.41,2.08,8.48,8.48,0,0,0,.41,2.25,6.37,6.37,0,0,0,1.78,3,3,3,0,0,0,1.48.61,3.55,3.55,0,0,0,1.46-.13h0a2.09,2.09,0,0,0,.94-.51,3.44,3.44,0,0,0,.62-.72,4,4,0,0,0,.5-1.43,3.58,3.58,0,0,0,0-1,2.19,2.19,0,0,0,0-.25.66.66,0,0,0,0-.09,5.27,5.27,0,0,1-.06,1.29,3.89,3.89,0,0,1-.52,1.38,2.9,2.9,0,0,1-.6.68,2,2,0,0,1-.87.46h0a3.08,3.08,0,0,1-2.76-.47,6.22,6.22,0,0,1-1.71-2.87,5.84,5.84,0,0,1,0-4.2,3.34,3.34,0,0,1,1.15-1.42,2.34,2.34,0,0,1,.77-.32,2.94,2.94,0,0,1,.77-.09,2.75,2.75,0,0,1,1.28.34,3.11,3.11,0,0,1,.82.6A7.13,7.13,0,0,1,415.46,221.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.92,221.9a2,2,0,0,1,2.29.63,3.39,3.39,0,0,1,.63,2.42,3,3,0,0,1-.33,1.26,1.67,1.67,0,0,1-1,.82,2,2,0,0,1-1.77-.5,3.59,3.59,0,0,1-1.27-2.71,1.66,1.66,0,0,1,1-1.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,222.15a.41.41,0,0,0-.15,0,.91.91,0,0,0-.37.24,2,2,0,0,0-.51,1.5,3.53,3.53,0,0,0,.82,2.21,3,3,0,0,0,1.11.88,1.69,1.69,0,0,0,1.53,0,2.11,2.11,0,0,0,.9-1.24,4.25,4.25,0,0,0,.14-1.4,3,3,0,0,0-.95-2.15,2.12,2.12,0,0,0-1.52-.49,1.75,1.75,0,0,0-.42.11c-.09.05-.13.07-.13.08a2.8,2.8,0,0,1,.56-.11,2,2,0,0,1,1.41.52,2.86,2.86,0,0,1,.87,2.05,4.45,4.45,0,0,1-.15,1.34,2,2,0,0,1-.81,1.12,1.53,1.53,0,0,1-1.35,0,2.93,2.93,0,0,1-1.05-.82,3.45,3.45,0,0,1-.82-2.1,2,2,0,0,1,.43-1.44A1.62,1.62,0,0,1,413.47,222.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.64,228.49s0-.13.13-.31a1.39,1.39,0,0,1,.52-.58,4,4,0,0,1,.75-.32c.2-.07.33-.12.33-.15a.81.81,0,0,0-.36,0,2.39,2.39,0,0,0-.82.29,1.29,1.29,0,0,0-.56.7C413.57,228.35,413.61,228.5,413.64,228.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.62,222s.09.12.3.21a1.92,1.92,0,0,0,1.72-.13c.19-.13.28-.24.26-.26a4.49,4.49,0,0,1-1.12.33A5.55,5.55,0,0,1,411.62,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.17,235.44c-1,.29-2.14-.45-3.12-.07a1.46,1.46,0,1,0,1.13,2.7c1-.46,1.23-1.9,2.19-2.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,239.05a6.3,6.3,0,0,0,.91-.38l-.16-.33a4.13,4.13,0,0,1-3.29.4,6.08,6.08,0,0,1-3.26-3.36l0-.07c-.36-.72-5.31-15.46-6.22-18.27a5,5,0,0,1,2.4-6.31c.14-.08,3.45-1.8,6.86,2.39,3.57,4.39,9.81,13,10.39,14.12l.27.48c.79,1.34,2.44,4.14,1,6.54-1.61,2.66-3.63,2.48-3.71,2.48l0,.36c.09,0,2.32.22,4.06-2.66,1.57-2.57-.16-5.5-1-6.91l-.26-.46c-.58-1.08-6.85-9.78-10.42-14.18s-7.28-2.5-7.32-2.48a5.46,5.46,0,0,0-2.57,6.74c.75,2.31,5.85,17.56,6.23,18.32l0,.07a6.38,6.38,0,0,0,3.46,3.55A4.18,4.18,0,0,0,388,239.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,219.92a6.65,6.65,0,0,1,.16-1.95,6,6,0,0,1,.89-1.93,6.29,6.29,0,0,1,1.88-1.77,6.87,6.87,0,0,1,4.56-.84,7.74,7.74,0,0,1,1.88.6s0,0-.12-.09a3.84,3.84,0,0,0-.34-.19,6,6,0,0,0-1.39-.45,6.47,6.47,0,0,0-2.18-.06,6.67,6.67,0,0,0-2.51.87,6.21,6.21,0,0,0-1.93,1.84,6,6,0,0,0-.87,2,4.74,4.74,0,0,0-.12,1.46c0,.17,0,.3.05.39S376.64,219.93,376.65,219.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.25 195.48 389.83 216.02 404.68 225.34 375.87 189.01 373.25 195.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.58,208.58s-3.48,5.48-4,11.08c-.22,2.19,5.24,43.32,5.85,45.17s7.87,6.47,10,7.4,28.52,9.71,39.31,9.56l2.31-20.35-27.75-4.63s-3.24-3.08-4.93-3.7l-2.32-22.66-3.39-18.19S364,206.28,358.58,208.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,233.21c-.14,0-1.63-6-3.33-13.44s-3-13.52-2.83-13.55,1.63,6,3.34,13.43S421.08,233.17,420.94,233.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69,228.44s0,.14.08.42.13.72.22,1.26c.18,1.13.44,2.76.77,4.87.65,4.26,1.6,10.42,2.78,18.09l-.11-.13a11.11,11.11,0,0,1,2.58,1.63c.82.65,1.62,1.35,2.42,2.09l-.1-.05,27.76,4.58.22,0,0,.22c-.72,6.36-1.49,13.22-2.3,20.35l0,.24h-.23a72.15,72.15,0,0,1-15.27-2.38c-6.4-1.53-12.56-3.36-18.47-5.25-1.47-.48-2.93-1-4.37-1.47a18.51,18.51,0,0,1-4.09-2c-1.27-.78-2.51-1.6-3.69-2.46a17.76,17.76,0,0,1-3.28-2.9,2,2,0,0,1-.47-1c-.09-.37-.15-.71-.2-1.06-.12-.7-.23-1.39-.34-2.07-.2-1.38-.4-2.73-.6-4.07l-1.08-7.77c-.68-5-1.29-9.7-1.82-14s-1-8.14-1.33-11.55c-.08-.85-.18-1.67-.23-2.47a8.94,8.94,0,0,1,0-2.31,27.4,27.4,0,0,1,.94-3.91,29.85,29.85,0,0,1,2.15-5.12c.29-.56.55-1,.72-1.25a2.8,2.8,0,0,1,.28-.4l-.24.43c-.15.28-.39.7-.67,1.27a32.71,32.71,0,0,0-2.05,5.13,27.71,27.71,0,0,0-.89,3.89,9.48,9.48,0,0,0,0,2.25c.06.79.16,1.61.25,2.46.37,3.4.86,7.26,1.41,11.53s1.2,9,1.88,14q.53,3.76,1.1,7.77c.2,1.33.41,2.68.62,4.05l.33,2.07c.06.34.12.69.2,1a1.65,1.65,0,0,0,.39.87,17.26,17.26,0,0,0,3.19,2.79c1.17.86,2.4,1.67,3.66,2.44a18.33,18.33,0,0,0,4,2c1.43.5,2.89,1,4.36,1.46,5.9,1.88,12,3.7,18.43,5.23a72.5,72.5,0,0,0,15.14,2.37l-.25.23c.82-7.13,1.6-14,2.33-20.35l.2.26L384.27,257h-.06l0,0c-.79-.74-1.58-1.44-2.39-2.08a10.78,10.78,0,0,0-2.47-1.59l-.1-.05,0-.09c-1.11-7.69-2-13.86-2.62-18.13-.29-2.1-.52-3.74-.68-4.87-.07-.54-.12-1-.16-1.27A3.4,3.4,0,0,1,375.69,228.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,222.33a17.18,17.18,0,0,1-1.28-2.47,28.07,28.07,0,0,0-3.46-5.66,12.42,12.42,0,0,0-5.3-3.78,19.66,19.66,0,0,0-2.68-.58,1.85,1.85,0,0,1,.75-.08,7.3,7.3,0,0,1,2.05.31,11.69,11.69,0,0,1,5.57,3.8,23.07,23.07,0,0,1,3.41,5.83A13.45,13.45,0,0,1,374.05,222.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.61,256.89a10.64,10.64,0,0,1,9.62-3.68,24.24,24.24,0,0,0-5.1,1.08A25.33,25.33,0,0,0,369.61,256.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.76,260.11a10.31,10.31,0,0,1,6.89-7,25.75,25.75,0,0,0-4,3A27,27,0,0,0,372.76,260.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.68,225.34a6.87,6.87,0,0,1-1.15-.62l-3.12-1.87-10.71-6.62,0,0,0,0-5-6.15c-4.58-5.68-8.69-10.82-11.54-14.43l-.07-.09,0-.09,2-4.71.56-1.26a1.56,1.56,0,0,1,.23-.43,1.93,1.93,0,0,1-.14.47c-.12.35-.28.77-.47,1.29-.46,1.2-1.08,2.8-1.85,4.77l0-.18c2.92,3.55,7.08,8.65,11.67,14.34l5,6.16-.06-.05,10.62,6.77,3,2A8.05,8.05,0,0,1,404.68,225.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.1,229.2a7.81,7.81,0,0,1,.11-1.34c.12-.94.27-2.16.46-3.64.41-3.08,1-7.37,1.72-12.2l0,.16c-.31-.58-.65-1.2-1-1.83-2.54-4.72-4.82-9-6.44-12.13l-1.89-3.7a9.5,9.5,0,0,1-.64-1.39,8.14,8.14,0,0,1,.81,1.29l2.05,3.63c1.7,3.07,4,7.33,6.56,12,.34.63.67,1.25,1,1.83l0,.08v.09c-.73,4.82-1.4,9.1-1.9,12.17-.25,1.47-.46,2.68-.62,3.62A6.09,6.09,0,0,1,407.1,229.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.69,211.39l.85-.52-.86.52a52,52,0,0,1-3.73-7l-.18-.43c-1-2.45-2.16-5.22-1.67-7.91V196a5.26,5.26,0,0,1,1.83-3l.27-.24H374v1.55l.18.21-.18.17v.07H374a3.14,3.14,0,0,0-.89,1.64v.05c-.36,2.1.66,4.57,1.56,6.75l.18.43a48.85,48.85,0,0,0,3.6,6.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.26,272.34a3.46,3.46,0,0,1,.14.75c.07.54.17,1.26.29,2.16.25,1.88.58,4.6,1,8,.77,6.73,1.72,16,2.59,26.34s1.49,19.64,1.87,26.4c.18,3.38.32,6.12.39,8,0,.91.05,1.63.07,2.18a4,4,0,0,1,0,.76,3.79,3.79,0,0,1-.09-.75c0-.55-.1-1.27-.17-2.18-.14-1.94-.33-4.66-.56-8-.47-6.75-1.15-16.08-2-26.38S415,290,414.28,283.25c-.33-3.33-.59-6-.79-8-.08-.9-.14-1.62-.19-2.17A6.17,6.17,0,0,1,413.26,272.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,295.8s-.22.26-.67.65-1.13.95-2,1.61a59.56,59.56,0,0,1-6.94,4.77,36.56,36.56,0,0,1-4.18,2.06,26.4,26.4,0,0,1-3.61,1.16,16.38,16.38,0,0,1-2.53.43,2.85,2.85,0,0,1-.94,0c0-.09,1.32-.24,3.37-.82a28.33,28.33,0,0,0,3.53-1.25,42.5,42.5,0,0,0,4.1-2.06c2.82-1.63,5.23-3.37,7-4.61A25.18,25.18,0,0,1,400.43,295.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,299.7a3.34,3.34,0,0,1-.54.8,18.76,18.76,0,0,1-1.73,2,28.27,28.27,0,0,1-15.21,8.09,18.91,18.91,0,0,1-2.62.32,4,4,0,0,1-1,0c0-.1,1.36-.2,3.52-.68a31.66,31.66,0,0,0,8.06-3,32.17,32.17,0,0,0,7-5C401,300.72,401.89,299.64,402,299.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,311.27a7.61,7.61,0,0,1-.54-2.74,7.32,7.32,0,0,1,0-2.79,14.92,14.92,0,0,1,.56,5.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,178.74a1.94,1.94,0,0,1-1.72-1.17,6.73,6.73,0,0,1-.58-2.24c-.47-3.4-.93-6.81-1.4-10.22a51.87,51.87,0,0,1-.71-8.71,18.56,18.56,0,0,1,2.57-8c1.54-3,7.78-8.19,18.13-5.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.66,166.48c-.14,0-5.53-1.52-5.26,4s5.72,4.07,5.72,3.91S377.66,166.48,377.66,166.48Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.34,172.35s-.09.07-.25.15a1,1,0,0,1-.71.06,2.39,2.39,0,0,1-1.2-2.07,3.07,3.07,0,0,1,.2-1.37,1.09,1.09,0,0,1,.68-.77.49.49,0,0,1,.58.23c.08.15.05.26.08.27s.11-.1,0-.32a.51.51,0,0,0-.23-.33.72.72,0,0,0-.53-.12,1.37,1.37,0,0,0-1,.9,3.36,3.36,0,0,0-.25,1.54,2.49,2.49,0,0,0,1.51,2.3,1.07,1.07,0,0,0,.87-.19C376.34,172.48,376.36,172.36,376.34,172.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.79,176.66c0-3.87-.72-11.83-1.43-19a14.93,14.93,0,0,0-15.13-13.45l-.77,0c-8.33.64-12.43,8.06-11.56,16.37l1.17,26.48,19.85,10.89-.07-11.87S405.84,184.67,405.79,176.66Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.86,186.06a18.58,18.58,0,0,1-10.49-2.77s2.52,5.8,10.5,4.94Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.71,162.88a1.14,1.14,0,0,1-1.08,1.17,1.09,1.09,0,0,1-1.2-1,1.14,1.14,0,0,1,1.08-1.17A1.1,1.1,0,0,1,401.71,162.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.82,161.16c-.14.15-1-.48-2.25-.45s-2.12.66-2.26.51.08-.34.46-.63a3.18,3.18,0,0,1,1.81-.59,3,3,0,0,1,1.79.54C402.76,160.82,402.89,161.09,402.82,161.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,163.13a1.13,1.13,0,0,1-1.08,1.17,1.08,1.08,0,0,1-1.19-1,1.13,1.13,0,0,1,1.08-1.17A1.08,1.08,0,0,1,389.74,163.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.55,161c-.12.16-1.06-.36-2.28-.2s-2,.88-2.19.75,0-.34.39-.68a3.07,3.07,0,0,1,1.73-.78,3,3,0,0,1,1.84.34C390.45,160.71,390.61,161,390.55,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.25,171.08a8,8,0,0,1,2-.4c.32,0,.61-.1.66-.32a1.6,1.6,0,0,0-.23-.93l-1-2.37a40.84,40.84,0,0,1-2.2-6.23,43.34,43.34,0,0,1,2.7,6c.32.84.63,1.63.93,2.39a1.83,1.83,0,0,1,.19,1.24.77.77,0,0,1-.51.46,1.89,1.89,0,0,1-.53.09A8,8,0,0,1,395.25,171.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,172c.2,0,.23,1.32,1.39,2.24s2.58.76,2.6.95-.32.26-.92.29a3.31,3.31,0,0,1-2.16-.71,2.92,2.92,0,0,1-1.08-1.89C391.41,172.32,391.55,172,391.64,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.62,155.73c-.11.33-1.35.2-2.79.4s-2.6.61-2.8.32.11-.46.58-.8a4.68,4.68,0,0,1,2.06-.76,4.74,4.74,0,0,1,2.19.21C390.4,155.31,390.67,155.57,390.62,155.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,158c-.21.28-1.06,0-2.08,0s-1.88.22-2.09-.06,0-.43.42-.7a2.84,2.84,0,0,1,1.68-.49,2.88,2.88,0,0,1,1.67.53C402.16,157.6,402.28,157.89,402.19,158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,143.33c-2.83-1.12-5.7-.53-8.71-.09a13.78,13.78,0,0,0-6.41,2.55,12.36,12.36,0,0,0-4.72,9.61,35.49,35.49,0,0,0,1.19,10.8l.3-.07a5.16,5.16,0,0,0-.05,2.78,1.8,1.8,0,0,0,2.21,1.21c1-.44,1-1.83,1-2.93a79.35,79.35,0,0,1,0-11.12c.16-2.76,1.73-6.15,3.89-7.46,3.93-2.62,9.05-.48,10.78-.18,2.67-2.28,5.16-.5,6.78,1.48C400.67,146.93,397.92,144.44,395.09,143.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,148.43c1.76,0,3.16-1.18,5.11-.86,1.18.19,2.37,2.12,3.4,4.52a3.47,3.47,0,0,0-1-6.35,3.21,3.21,0,0,0,1.56.51,1.09,1.09,0,0,0,1.1-1,1.46,1.46,0,0,0-.65-1,8.55,8.55,0,0,0-12,1.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.52,145.12c0,.07-.57-.3-1.52-.6a6.12,6.12,0,0,0-3.75,0,6.2,6.2,0,0,0-3,2.31c-.56.82-.73,1.43-.82,1.41a2.94,2.94,0,0,1,.51-1.6,5.7,5.7,0,0,1,7.16-2.49C403.11,144.58,403.56,145.08,403.52,145.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,151.15a6.82,6.82,0,0,0,0-1.86,4,4,0,0,0-.88-1.75,4.19,4.19,0,0,0-2-1.22,5.53,5.53,0,0,0-4.27.74c-1,.62-1.48,1.18-1.54,1.12s.35-.69,1.34-1.42a6,6,0,0,1,1.94-.94,5.21,5.21,0,0,1,2.66,0,4.42,4.42,0,0,1,2.27,1.41,4,4,0,0,1,.87,2A2.39,2.39,0,0,1,403.15,151.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,164.33s-.12-.25-.21-.73a10.42,10.42,0,0,1-.18-2.06,13.74,13.74,0,0,1,1.66-6.59,13.93,13.93,0,0,1,4.61-5,11.21,11.21,0,0,1,1.82-1,1.92,1.92,0,0,1,.73-.23c0,.08-1,.5-2.35,1.51a14.63,14.63,0,0,0-6.11,11.3C374.55,163.26,374.75,164.32,374.66,164.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,165.34a12.35,12.35,0,0,1,3.69-11.09,25.64,25.64,0,0,0-2.75,5.24A25.52,25.52,0,0,0,375.88,165.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.39,211.12c-.23-.61-1.39-.74-1.39-.74l.23-.35a1.67,1.67,0,0,0,.12-1.67l-.13-.25a2.81,2.81,0,0,0-1.34-1s.85-1.16.64-1.73a2.73,2.73,0,0,0-2.61-1.53,40.64,40.64,0,0,0-5.45,1.62,1.21,1.21,0,0,1-1.61-.89,17.24,17.24,0,0,0-1.75-5c-1-1.68-2.17-1.74-2.88-1.58a.56.56,0,0,0-.4.76,29.38,29.38,0,0,1,1.27,3.52c.19.9-.46,7.41-.46,7.41l-3.31,4.45,7.5,10.83,3.3-4.9,7.07-3.11s1.34-1.69,1.2-2.27a1.77,1.77,0,0,0-.7-.93l.88-1.23A3.77,3.77,0,0,0,466.39,211.12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.51,207.29l-.14.09-.44.25-1.61.9-2.4,1.3c-.46.24-.92.52-1.45.74a1.91,1.91,0,0,1-1.74,0,1.31,1.31,0,0,1-.54-.75,1.91,1.91,0,0,1,0-.89,2.44,2.44,0,0,1,.91-1.35,9.38,9.38,0,0,1,1.23-.82l1.09-.65,1.59-.94.44-.24.15-.08s0,0-.14.11l-.42.27-1.56,1-1.08.67a10.54,10.54,0,0,0-1.2.81,2.41,2.41,0,0,0-.85,1.28,1.36,1.36,0,0,0,.48,1.46,1.44,1.44,0,0,0,.79.21,2.39,2.39,0,0,0,.8-.18c.51-.21,1-.49,1.43-.72l2.42-1.28,1.64-.84.45-.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.47,210.54a1.46,1.46,0,0,1-.34.2c-.22.12-.54.29-.95.48-.81.4-1.94.91-3.22,1.42a7.22,7.22,0,0,1-.95.34,1.85,1.85,0,0,1-1,0,1.48,1.48,0,0,1-1.06-1.17,1.4,1.4,0,0,1,.25-1,.9.9,0,0,1,.19-.22l.09-.06s-.1.1-.23.31a1.45,1.45,0,0,0-.19,1,1.39,1.39,0,0,0,1,1,1.81,1.81,0,0,0,.89,0c.3-.08.61-.22.93-.34,1.27-.51,2.41-1,3.23-1.37l1-.44A1.7,1.7,0,0,1,465.47,210.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.84,213.62a1.11,1.11,0,0,1-.33.13l-.94.31-3.12.94c-.31.08-.6.18-.91.23a1.58,1.58,0,0,1-.89-.06,1,1,0,0,1-.58-.58,1.15,1.15,0,0,1,0-.71,1.49,1.49,0,0,1,.65-.76,1,1,0,0,1,.33-.15,3.52,3.52,0,0,1-.29.2,1.55,1.55,0,0,0-.57.75,1,1,0,0,0,0,.63.8.8,0,0,0,.51.47,1.46,1.46,0,0,0,.81,0c.28,0,.58-.15.88-.23,1.22-.36,2.33-.68,3.13-.89l1-.26Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.88,216.44a8.09,8.09,0,0,1-1.07.11l-2.57.14-.74,0a2.74,2.74,0,0,1-.7,0,1,1,0,0,1-.57-.31.63.63,0,0,1-.15-.56.93.93,0,0,1,.5-.62.47.47,0,0,1,.28-.07,2,2,0,0,0-.25.13.9.9,0,0,0-.42.58.56.56,0,0,0,.14.45.85.85,0,0,0,.5.25,3,3,0,0,0,.67,0l.73,0c1,0,1.92-.08,2.58-.09A6.51,6.51,0,0,1,465.88,216.44Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.1,214a9.59,9.59,0,0,0-1.8-.47,9.29,9.29,0,0,0-1.86.08,4.09,4.09,0,0,1,3.66.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.91,262.63l1.56-.4s.54-2.61,1.23-3.16,7.56-3.68,9.07-4.5,7.41-3.51,8.15-2.09c.84,1.62-1.57,3-2.87,3.57s-5,2.06-4.27,2.95,9.07.49,9.07.49l1-1.4s1.83,1.73,1.62,3.24a6.51,6.51,0,0,1-.82,2.47h-.62a1.72,1.72,0,0,1,.07,1.79,16.59,16.59,0,0,1-1.64,2.05,6.12,6.12,0,0,1-3.91,2.86c-.35.09-14.07,1.29-14.07,1.29l-4.6.46Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.84,58.7,100.42,45.28,64.36,58.52c-4.61,2.23-8.64,3.56-8.64,8V88.39A84.33,84.33,0,0,0,67.6,132,74.57,74.57,0,0,0,100.78,162c14.74-4.91,25.74-18,32.47-29.21a84.4,84.4,0,0,0,11.88-43.59V69.54C145.13,63.27,141.89,60.21,136.84,58.7Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.84,58.7,100.42,45.28,64.36,58.52c-4.61,2.23-8.64,3.56-8.64,8V88.39A84.33,84.33,0,0,0,67.6,132,74.57,74.57,0,0,0,100.78,162c14.74-4.91,25.74-18,32.47-29.21a84.4,84.4,0,0,0,11.88-43.59V69.54C145.13,63.27,141.89,60.21,136.84,58.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,67.59,100.42,56.83,71.49,67.44c-3.7,1.79-6.94,2.86-6.94,6.39V91.41a67.66,67.66,0,0,0,9.54,35,59.79,59.79,0,0,0,26.62,24.12c11.82-3.94,20.65-14.45,26.05-23.43a67.75,67.75,0,0,0,9.53-35V76.29C136.29,71.26,133.69,68.8,129.64,67.59Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.54 97.79 105.36 97.79 105.36 80.6 95.49 80.6 95.49 97.79 78.3 97.79 78.3 107.66 95.49 107.66 95.49 124.84 105.36 124.84 105.36 107.66 122.54 107.66 122.54 97.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.65,147.85s.16-.24.5-.69l.29-.37c.1-.15.18-.32.29-.5a7.72,7.72,0,0,0,.65-1.29c.1-.26.22-.52.32-.81s.17-.61.26-.93a6.84,6.84,0,0,0,.21-1,10,10,0,0,0,.16-1.15,21.63,21.63,0,0,0-.25-5.51A49.64,49.64,0,0,0,152,121.29a111.35,111.35,0,0,0-10.88-16.92,173.16,173.16,0,0,0-16.22-18.22A199.27,199.27,0,0,0,103.61,68c-4-2.93-8.17-5.76-12.59-8.43a121,121,0,0,0-14-7.33,65,65,0,0,0-15.56-4.88,27.48,27.48,0,0,0-8.3-.2,15.23,15.23,0,0,0-4,1.16,10,10,0,0,0-5.43,6.08,15.53,15.53,0,0,0-.7,4.11,27.52,27.52,0,0,0,1.15,8.23,65.09,65.09,0,0,0,6.61,14.91,123.15,123.15,0,0,0,8.88,13.06c3.16,4.09,6.45,7.93,9.81,11.55A199.41,199.41,0,0,0,90,125.33a173.09,173.09,0,0,0,20,14,111,111,0,0,0,18,8.88,49.58,49.58,0,0,0,14.75,3.41,21.41,21.41,0,0,0,5.51-.38,9.16,9.16,0,0,0,1.12-.28,6,6,0,0,0,1-.34l.9-.36c.27-.13.52-.28.76-.41a6.86,6.86,0,0,0,1.21-.79c.17-.12.33-.23.46-.34l.34-.33c.41-.39.63-.58.63-.58l-.6.6-.34.34c-.13.11-.29.22-.46.35A7.45,7.45,0,0,1,152,150l-.76.42-.9.37a6.3,6.3,0,0,1-1,.34,11.61,11.61,0,0,1-1.13.3,21.93,21.93,0,0,1-5.53.41,49.64,49.64,0,0,1-14.81-3.37,111.07,111.07,0,0,1-18.1-8.85,174.16,174.16,0,0,1-20-14,198.69,198.69,0,0,1-20.54-19.1c-3.36-3.63-6.66-7.47-9.83-11.57a121.76,121.76,0,0,1-8.91-13.09,65.66,65.66,0,0,1-6.65-15,27.69,27.69,0,0,1-1.15-8.32,15.94,15.94,0,0,1,.71-4.21,11.68,11.68,0,0,1,2.14-3.73A11.56,11.56,0,0,1,49,48a16,16,0,0,1,4.09-1.19,27.79,27.79,0,0,1,8.4.21,65.79,65.79,0,0,1,15.64,4.9,122.31,122.31,0,0,1,14,7.36c4.43,2.68,8.63,5.52,12.61,8.45A199.82,199.82,0,0,1,125.1,86a174.19,174.19,0,0,1,16.21,18.28,110.2,110.2,0,0,1,10.86,17,49.41,49.41,0,0,1,5,14.33,21.78,21.78,0,0,1,.23,5.54c0,.41-.12.79-.17,1.15a8.11,8.11,0,0,1-.22,1.05c-.1.32-.19.64-.27.93s-.23.56-.33.81a8.23,8.23,0,0,1-.67,1.3c-.11.18-.2.35-.29.49l-.3.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,99.25s0-.29-.08-.85c0-.14,0-.3,0-.47s-.08-.36-.12-.56a7.81,7.81,0,0,0-.38-1.4c-.09-.25-.18-.53-.3-.82l-.42-.86a6.29,6.29,0,0,0-.54-.92,8.89,8.89,0,0,0-.64-1,21.21,21.21,0,0,0-3.86-4,49.43,49.43,0,0,0-13.28-7.27,111.55,111.55,0,0,0-19.38-5.39A174.22,174.22,0,0,0,111.51,73a198.52,198.52,0,0,0-28,.61c-4.92.47-9.93,1.15-15,2.1a122.08,122.08,0,0,0-15.32,3.83,65.49,65.49,0,0,0-14.85,6.72A27.34,27.34,0,0,0,32,91.63a15.49,15.49,0,0,0-2.22,3.54,10,10,0,0,0,0,8.15A15.49,15.49,0,0,0,32,106.86a27.63,27.63,0,0,0,6.33,5.38A65.36,65.36,0,0,0,53.19,119a123.46,123.46,0,0,0,15.32,3.84c5.08,1,10.09,1.62,15,2.09a198.66,198.66,0,0,0,28,.61,172.56,172.56,0,0,0,24.23-2.8,112.61,112.61,0,0,0,19.39-5.38A49.51,49.51,0,0,0,168.41,110a21.21,21.21,0,0,0,3.86-4,10.83,10.83,0,0,0,.65-1,7.23,7.23,0,0,0,.53-.92l.43-.86c.11-.29.2-.56.29-.82a7.81,7.81,0,0,0,.38-1.4c0-.2.09-.39.12-.56s0-.33,0-.47c.05-.56.08-.85.08-.85s0,.29,0,.85l0,.48c0,.17-.07.36-.11.56a7,7,0,0,1-.37,1.41c-.09.26-.17.54-.29.83s-.27.57-.42.87a6.7,6.7,0,0,1-.53.93,10.79,10.79,0,0,1-.64,1,21.63,21.63,0,0,1-3.86,4,49.5,49.5,0,0,1-13.29,7.35,111.62,111.62,0,0,1-19.4,5.44,172.91,172.91,0,0,1-24.27,2.84,199,199,0,0,1-28-.58c-4.92-.46-9.95-1.14-15-2.09a121,121,0,0,1-15.36-3.84,65.56,65.56,0,0,1-14.94-6.75,27.67,27.67,0,0,1-6.4-5.44,16,16,0,0,1-2.27-3.62,11.62,11.62,0,0,1-.89-4.21,11.42,11.42,0,0,1,.9-4.2,15.63,15.63,0,0,1,2.27-3.62A27.87,27.87,0,0,1,38.16,86a65.69,65.69,0,0,1,14.93-6.75A121.85,121.85,0,0,1,68.45,75.4c5.09-1,10.12-1.62,15-2.09a199,199,0,0,1,28-.58,171.22,171.22,0,0,1,24.26,2.85A110.87,110.87,0,0,1,155.2,81a49.5,49.5,0,0,1,13.29,7.34,21.63,21.63,0,0,1,3.86,4,10.79,10.79,0,0,1,.64,1,8.1,8.1,0,0,1,.53.93l.42.88c.12.28.2.56.29.82a7.22,7.22,0,0,1,.37,1.41c0,.2.08.39.11.57l0,.47C174.77,99,174.78,99.25,174.78,99.25Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,38.76l-.71-.46L147,38c-.15-.09-.33-.16-.51-.25a8.2,8.2,0,0,0-1.34-.56l-.83-.27-.95-.19a6.66,6.66,0,0,0-1.05-.14,10.56,10.56,0,0,0-1.15-.08,21.76,21.76,0,0,0-5.49.63,49.48,49.48,0,0,0-13.88,6,111.27,111.27,0,0,0-16.13,12A172.12,172.12,0,0,0,88.6,72.68a197.25,197.25,0,0,0-16.67,22.5c-2.64,4.17-5.18,8.55-7.54,13.14A120.86,120.86,0,0,0,58,122.78a65.14,65.14,0,0,0-3.8,15.86,27.5,27.5,0,0,0,.37,8.29A15.76,15.76,0,0,0,56,150.85a10.07,10.07,0,0,0,6.44,5,15.32,15.32,0,0,0,4.16.41,27.42,27.42,0,0,0,8.12-1.7,65.31,65.31,0,0,0,14.42-7.63,119.83,119.83,0,0,0,12.42-9.76c3.87-3.43,7.47-7,10.85-10.58a197.85,197.85,0,0,0,17.64-21.75A173.2,173.2,0,0,0,142.73,84a111.74,111.74,0,0,0,7.62-18.62,49.82,49.82,0,0,0,2.38-14.95,21.6,21.6,0,0,0-.76-5.47c-.08-.39-.25-.74-.36-1.1a7.17,7.17,0,0,0-.4-1q-.22-.45-.42-.87c-.16-.26-.32-.5-.47-.73a7.29,7.29,0,0,0-.87-1.16c-.13-.15-.25-.31-.37-.43l-.35-.32-.63-.58s.23.18.65.56l.36.31c.12.12.24.27.38.43a7.81,7.81,0,0,1,.89,1.15c.15.23.32.47.47.74s.28.56.43.87a5.76,5.76,0,0,1,.41,1c.12.36.29.71.38,1.1a21.77,21.77,0,0,1,.79,5.5,49.62,49.62,0,0,1-2.34,15,110.61,110.61,0,0,1-7.59,18.67A171.27,171.27,0,0,1,130.31,105a196,196,0,0,1-17.64,21.81c-3.38,3.61-7,7.17-10.86,10.61a121.75,121.75,0,0,1-12.45,9.78,64.88,64.88,0,0,1-14.49,7.67,27.59,27.59,0,0,1-8.22,1.73,16.06,16.06,0,0,1-4.25-.42,11.79,11.79,0,0,1-3.87-1.88A11.61,11.61,0,0,1,55.76,151a15.85,15.85,0,0,1-1.47-4,27.54,27.54,0,0,1-.37-8.39,65.56,65.56,0,0,1,3.81-15.94,122.34,122.34,0,0,1,6.38-14.49c2.37-4.61,4.91-9,7.56-13.16A198,198,0,0,1,88.39,72.5a172.37,172.37,0,0,1,17.12-17.44,110,110,0,0,1,16.19-12,49.15,49.15,0,0,1,14-6,21.36,21.36,0,0,1,5.51-.61,10.5,10.5,0,0,1,1.16.09,6.94,6.94,0,0,1,1.06.15l1,.2c.3.09.57.19.83.28a8.17,8.17,0,0,1,1.34.57c.18.1.36.17.51.26l.39.27Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,129.39a2.71,2.71,0,1,1-3.84,0A2.7,2.7,0,0,1,28,129.39Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,45.36a2.71,2.71,0,1,1-2.71-2.71A2.71,2.71,0,0,1,181,45.36Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08,138.3a.69.69,0,1,1-.69-.69A.69.69,0,0,1,45.08,138.3Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,62.32a.69.69,0,1,1-.69-.69A.69.69,0,0,1,59.79,62.32Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,99.25a.69.69,0,1,1-.69-.69A.69.69,0,0,1,167.33,99.25Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,67.12a.69.69,0,1,1-.69-.68A.68.68,0,0,1,176.9,67.12Z",
    style: {
      fill: "#7E57C2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.c5151e0d0304647ab8b8908acdeda8bf.svg";
export { ForwardRef as ReactComponent };